import { api } from '@/services'

export async function removeProductRequest(
  checkoutId: string,
  productId: string
) {
  try {
    const { data } = await api.post('Cart/RemoveProduct', null, {
      params: {
        CheckoutId: checkoutId,
        ProductId: productId
      }
    })

    return { data }
  } catch (error) {
    console.error(error)
  }
}
